import { API_URL } from '../constants';
import queryString from 'query-string';

export type Params = { [key: string]: string | string[] | undefined } | string[];

export function stringifyParams(queryParams: Params) {
  let params = queryParams;

  if (Array.isArray(queryParams)) {
    params = queryParams.map((item) => JSON.stringify(item));
  }

  return queryString.stringify(params);
}

export function buildApiUrl(path: string, query: Params = {}) {
  const url = new URL(path, API_URL);

  return `${url.toString()}?${stringifyParams(query)}`;
}
